import { useMemo } from 'react';
import clsx from 'clsx';
import { Box, DOTS_TYPE, POSITION_TYPES, SwiperCarousel } from '@alf/uikit';
import { useDeviceStore } from '@namespace/device';
import { useColorScheme } from '@namespace/themes';
import JackpotByProvider from '../JackpotByProvider';
import { DISPLAY_TYPES } from '../JackpotByProvider/constants';

import styles from './index.module.css';

export const JackpotCarousel = ({ preparedJackpots, rotationSpeed }) => {
  const { isDesktop, isMobile } = useDeviceStore();

  const { isDarkModeEnabled } = useColorScheme();
  const slides = useMemo(
    () =>
      preparedJackpots.map((jackpot) => (
        <div key={jackpot.id} className={styles.jackpotSliderItem}>
          <JackpotByProvider
            {...jackpot}
            displayType={DISPLAY_TYPES.MULTIPLE}
            carouselWrapperData={{
              preparedJackpots,
              providerLogoVisibleByDefault: isMobile
            }}
          />
        </div>
      )),
    [preparedJackpots, isMobile]
  );

  const rotationInterval = Number.isNaN(Number(rotationSpeed))
    ? 0
    : Number(rotationSpeed);
  return (
    <Box
      align="center"
      className={clsx([
        preparedJackpots.length > 2 && styles.jackpotCarouselWrapper
      ])}
    >
      <SwiperCarousel
        rotationInterval={rotationInterval}
        autoPlay={!!rotationInterval}
        animationDuration={500}
        circular={true}
        navigation={{
          arrows: isDesktop,
          dots: {
            type: DOTS_TYPE.SMALL,
            position: POSITION_TYPES.INSIDE,
            dotsContainerClassName: styles.sliderDots
          }
        }}
        className={styles.jackpotCarousel}
        arrow={{
          name: 'icons/general/nav/back',
          leftClass: clsx([
            styles.sliderArrow,
            styles.sliderArrowLeft,
            isDarkModeEnabled && styles.sliderArrowDark
          ]),
          rightClass: clsx([
            styles.sliderArrow,
            styles.sliderArrowRight,
            isDarkModeEnabled && styles.sliderArrowDark
          ]),
          size: 'm',
          isHideAtEdge: false
        }}
        slidesPerView={preparedJackpots.length > 2 ? 1.08 : 1}
        spaceBetween={8}
        breakpoints={
          preparedJackpots.length > 4
            ? {
                0: { slidesPerView: 1.08 },
                1418: { slidesPerView: 2.1 }
              }
            : null
        }
      >
        {slides}
      </SwiperCarousel>
    </Box>
  );
};
